import { useConfig } from '@revenuewell/front-end-bundle';
import { FC, useState } from 'react';

import { FrameContainer, Spinner } from './practice-portal-frame.styles';

interface PracticePortalFrameProps {
  path: string;
  title: string;
}

export const PracticePortalFrame: FC<PracticePortalFrameProps> = ({ path, title }) => {
  const { config } = useConfig();
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const src = `${config.practice.url}${path}`;

  return (
    <FrameContainer>
      {isIframeLoading && <Spinner />}
      <iframe
        title={title}
        src={src}
        style={{
          width: isIframeLoading ? 0 : '100%',
          height: isIframeLoading ? 0 : '100%',
          border: 'none',
          visibility: isIframeLoading ? 'hidden' : 'visible'
        }}
        onLoad={() => setIsIframeLoading(false)}
      />
    </FrameContainer>
  );
};
